<div class="notifications">
    <div *ngFor="let notification of notifications" 
         class="notification" 
         [ngClass]="className(notification)"
         (click)="closeNotification(notification); $event.stopPropagation()">
		<ng-container 
		     *ngTemplateOutlet="notificationTpl;context:{notification:notification}">
		</ng-container>
	</div>
</div>

<ng-template #notificationTpl let-notification="notification">
	<div class="title" 
	     style="display: flex; justify-content: space-between; align-items: center;">
	    <div style="width:345px;margin:auto;padding: 10px;">
	        {{notification.title}}
		</div> 
	</div>
	<div class="message" [innerHTML]="notification.message"></div>
</ng-template>
